import {
  FETCH_ATTENDANCE_DETAILS_REQUEST,
  FETCH_ATTENDANCE_DETAILS_SUCCESS,
  FETCH_ATTENDANCE_DETAILS_FAILURE,
  FETCH_ATTENDANCE_MONTHLY_REQUEST,
  FETCH_ATTENDANCE_MONTHLY_SUCCESS,
  FETCH_ATTENDANCE_MONTHLY_FAILURE,
} from "../constants/AttendanceDetailsConstants";
import AttendanceDetailsService from "../service/AttendanceDetailsService";

export const fetchAttendanceDetails = (bdate, sno = "", loc = "") => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ATTENDANCE_DETAILS_REQUEST });

    const data = await AttendanceDetailsService.getAttendanceDetails(bdate, sno, loc);

    dispatch({
      type: FETCH_ATTENDANCE_DETAILS_SUCCESS,
      payload: data,
    });

    console.log("Attendance details loaded successfully:", data);
  } catch (error) {
    console.error("Error in fetchAttendanceDetails action:", error);
    dispatch({
      type: FETCH_ATTENDANCE_DETAILS_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch attendance details",
    });
  }
};

let monthlyRequestId = 0;

export const fetchAttendanceMonthly = (fromDate, toDate, loc = "") => async (dispatch) => {
  const id = ++monthlyRequestId;
  try{
    dispatch({type: FETCH_ATTENDANCE_DETAILS_REQUEST});
    const data = await AttendanceDetailsService.getMonthly(fromDate, toDate, loc);
    if(id!== monthlyRequestId) return;
    dispatch({type: FETCH_ATTENDANCE_DETAILS_SUCCESS, payload:data});
  }catch(error){
    if(id!==monthlyRequestId) return;
    dispatch({type:FETCH_ATTENDANCE_MONTHLY_FAILURE, payload: error.response?.data?.message || error.message || "Failed to fetch monthly attendance"});
  }
};
